import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroller'
import classNames from 'classnames'
import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import WhiteBox from '../../components/WhiteBox'
import paymentIcon from '../../assets/images/payment/payment.png'
import balanceIcon from '../../assets/images/payment/balance.png'
import noRecordIcon from '../../assets/images/payment/no-record.png'
import replySlipPaymentIcon from '../../assets/images/payment/reply-slip-payment.png'
import {
  dateTimeFormatter,
  moneyFormatter,
  signedMoneyAmountFormatter,
} from '../../utils/formatter'
import { getUser, getWalletRecords } from '../../reducers/user'
import PopupModal from '../../components/PopupModal'
import addValueIcon from '../../assets/images/payment/add-value.png'
import walletRecordIcon from '../../assets/images/payment/wallet-record.png'
import addValuePigIcon from '../../assets/images/payment/add-value-pig.png'
import StyleButton from '../../components/StyleButton'
import TabBar from '../../components/TabBar'
import { createEndSelector } from '../../reducers/selector'
import { FETCH_INVOICES, fetchInvoices } from '../../actions/invoice'
import { FETCH_WALLET_RECORDS, fetchWalletRecords } from '../../actions/user'
import { getInvoices } from '../../reducers/invoice'

const styles = () => {
  return {
    list: {
      marginTop: '10px',
      marginLeft: '-15px',
      marginRight: '-15px',
      height: 'calc(100vh - 20vh + 20px - 10px - 70px)',
      overflowY: 'auto',
    },
    listItem: {
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    popupModalButtonContainer: {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    popupModalButton: {
      marginBottom: '5px',
    },
    walletExpenseLabel: {
      color: 'red',
    },
    walletRedeemLabel: {
      color: 'green',
    },
    whiteBoxContainer: {
      marginTop: '10px',
    },
    noRecordContainer: {
      textAlign: 'center',
    },
    noRecordImage: {
      width: '25%',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    invoices: getInvoices(state),
    isInvoicesEnd: createEndSelector([FETCH_INVOICES])(state),
    walletRecords: getWalletRecords(state),
    isWalletRecordsEnd: createEndSelector([FETCH_WALLET_RECORDS])(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchWalletRecords(offset) {
      dispatch(fetchWalletRecords(offset))
    },
    fetchInvoices(invoiceType, offset) {
      dispatch(fetchInvoices(invoiceType, offset))
    },
  }
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
class WalletHomePage extends Component {
  state = {
    initialLoad: true,
    displayAddValuePopup: false,
    selectedTabIndex: 0,
  }

  get tabList() {
    const { t } = this.props
    return [
      {
        name: t('account_record'),
        id: 'accountRecord',
      },
      {
        name: t('invoice'),
        id: 'invoice',
      },
    ]
  }

  get selectedTab() {
    const { selectedTabIndex } = this.state
    return this.tabList[selectedTabIndex]
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState(
      {
        selectedTabIndex,
      },
      () => {
        this.handlePullToRefresh()
      },
    )
  }

  get listItems() {
    const { t, match } = this.props
    return [
      {
        id: 'addValue',
        icon: addValueIcon,
        name: t('add_value'),
      },
      {
        id: 'payment',
        icon: paymentIcon,
        name: t('payment'),
        path: `/school/${match.params.schoolCode}/user/invoices`,
      },
      {
        id: 'accountRecord',
        icon: walletRecordIcon,
        name: t('account_record'),
        path: `/school/${match.params.schoolCode}/user/wallet/records`,
      },
    ]
  }

  get invoiceList() {
    const { invoices } = this.props
    return invoices.inProgress || []
  }

  handleListItemClick = (listItem) => {
    return () => {
      if (listItem.id === 'addValue') {
        this.setState({
          displayAddValuePopup: true,
        })
      }
      if (!listItem.path) {
        return
      }
      const { history } = this.props
      history.push(listItem.path)
    }
  }

  handleOnlineAddValueClick = () => {
    const { history, match } = this.props
    history.push(`/school/${match.params.schoolCode}/user/wallet/addValue`)
  }

  handleBankTransferClick = () => {
    const { history, match } = this.props
    history.push(`/school/${match.params.schoolCode}/user/wallet/redeem/bank_transfer`)
  }

  handleDisplayAddValuePopupDismiss = () => {
    this.setState({
      displayAddValuePopup: false,
    })
  }

  handlePullToRefresh = () => {
    console.log('handlePullToRefresh')
    if (this.selectedTab.id === 'accountRecord') {
      this.props.fetchWalletRecords(0)
    }
    if (this.selectedTab.id === 'invoice') {
      this.props.fetchInvoices('inProgress', 0)
    }
  }

  handleLoadMore = () => {
    if (this.selectedTab.id === 'accountRecord') {
      const { walletRecords } = this.props
      this.props.fetchWalletRecords(walletRecords.length)
    }
    if (this.selectedTab.id === 'invoice') {
      this.props.fetchInvoices('inProgress', this.invoiceList.length)
    }
  }

  handleInvoiceClick = (invoiceId) => {
    return () => {
      const { history, match } = this.props
      history.push(`/school/${match.params.schoolCode}/invoice/${invoiceId}`)
    }
  }

  handleRecordClick = (record) => {
    return () => {
      if (record.type === 'EXPENSE' && record.model_type === 'App\\Invoice' && record.amount <= 0) {
        const { history, match } = this.props
        history.push(`/school/${match.params.schoolCode}/invoice/${record.model_id}`)
      }
    }
  }

  componentDidMount() {
    // this.props.fetchWalletRecords()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.initialLoad) {
      this.setState({
        initialLoad: false,
      })
    }
  }

  render() {
    const { selectedTabIndex, displayAddValuePopup } = this.state
    const {
      classes, user, walletRecords, isWalletRecordsEnd, t, isInvoicesEnd,
    } = this.props
    return (
      <MobileWrapper overlay={true}>
        <MobileHeader title={t('wallet')}>
          <TabBar
            tabs={this.tabList}
            selectedTabIndex={selectedTabIndex}
            onChange={this.handleTabChange}
          />
        </MobileHeader>
        {displayAddValuePopup && (
          <PopupModal
            title={t('add_value')}
            icon={addValuePigIcon}
            onDismiss={this.handleDisplayAddValuePopupDismiss}
          >
            <p>Please select add value method</p>
            <div className={classes.popupModalButtonContainer}>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('online_add_value')}
                  styleType={'secondary'}
                  onClick={this.handleOnlineAddValueClick}
                />
              </div>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('bank_transfer')}
                  styleType={'secondary'}
                  onClick={this.handleBankTransferClick}
                />
              </div>
            </div>
          </PopupModal>
        )}
        <MobileContent scrollable={false}>
          <div className={classes.whiteBoxContainer}>
            <WhiteBox
              title={`${t('spc_wallet')}$${moneyFormatter(user.wallet_balance)}`}
              description={t('my_balance')}
              image={balanceIcon}
            />
          </div>
          <div className={classes.list}>
            {this.selectedTab.id === 'accountRecord' && (
              <InfiniteScroll
                initialLoad={this.state.initialLoad}
                hasMore={!isWalletRecordsEnd}
                loader={<h4 key={0}>{t('loading')}</h4>}
                loadMore={this.handleLoadMore}
                threshold={70}
                useWindow={false}
              >
                {walletRecords.map((walletRecord) => {
                  return (
                    <div
                      className={classes.listItem}
                      key={walletRecord.id}
                      onClick={this.handleRecordClick(walletRecord)}
                    >
                      <WhiteBox
                        title={
                          !walletRecord.reason
                            ? walletRecord.type === 'EXPENSE'
                              ? `${t('expense')}`
                              : `${t('redeem')}`
                            : `${
                              walletRecord.type === 'EXPENSE'
                                ? `${t('expense')}`
                                : `${t('redeem')}`
                            } - ${walletRecord.reason}`
                        }
                        image={walletRecord.type === 'EXPENSE' ? paymentIcon : walletRecordIcon}
                        description={dateTimeFormatter(walletRecord.created_at)}
                        rightLabel={
                          <div
                            className={classNames({
                              [classes.walletExpenseLabel]: walletRecord.amount < 0,
                              [classes.walletRedeemLabel]: walletRecord.amount > 0,
                            })}
                          >
                            {signedMoneyAmountFormatter(walletRecord.amount)}
                          </div>
                        }
                      />
                    </div>
                  )
                })}
              </InfiniteScroll>
            )}
            {this.selectedTab.id === 'accountRecord'
              && isWalletRecordsEnd
              && walletRecords.length === 0 && (
                <div className={classes.noRecordContainer}>
                  <img src={noRecordIcon} className={classes.noRecordImage} alt="" />
                  <div>{t('no_payment_record')}</div>
                </div>
            )}
            {this.selectedTab.id === 'invoice' && (
              <InfiniteScroll
                initialLoad={this.state.initialLoad}
                hasMore={!isInvoicesEnd}
                loader={<h4 key={0}>{t('loading')}</h4>}
                loadMore={this.handleLoadMore}
                threshold={70}
                useWindow={false}
              >
                {this.invoiceList.map((invoice) => {
                  return (
                    <div className={classes.listItem} key={invoice.id}>
                      <WhiteBox
                        title={invoice.name || `${t('invoice_no')}${invoice.id}`}
                        image={replySlipPaymentIcon}
                        description={
                          invoice.expired_at
                            ? `${t('payment_deadline')}: ${dateTimeFormatter(invoice.expired_at)}`
                            : ''
                        }
                        onClick={this.handleInvoiceClick(invoice.id)}
                      />
                    </div>
                  )
                })}
              </InfiniteScroll>
            )}
            {this.selectedTab.id === 'invoice' && isInvoicesEnd && this.invoiceList.length === 0 && (
              <div className={classes.noRecordContainer}>
                <img src={noRecordIcon} className={classes.noRecordImage} alt="" />
                <div>{t('no_payment_record')}</div>
              </div>
            )}
          </div>
        </MobileContent>
      </MobileWrapper>
    )
  }
}

WalletHomePage.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  isWalletRecordsEnd: PropTypes.bool,
  walletRecords: PropTypes.array,
  fetchWalletRecords: PropTypes.func,
  isInvoicesEnd: PropTypes.bool,
  invoices: PropTypes.object,
  fetchInvoices: PropTypes.func,
  t: PropTypes.func,
}

export default WalletHomePage
